import { FormEvent, useCallback } from 'react'

type submitType = (event: FormEvent<HTMLFormElement>) => void

type UseEnterSubmitProps = {
  onEnterSubmit: submitType
}

export const useEnterSubmit = (handleSubmit: submitType): UseEnterSubmitProps => {
  const onEnterSubmit = useCallback(
    (event: React.KeyboardEvent<HTMLFormElement>) => {
      if (event.key === 'Enter') {
        handleSubmit(event as unknown as React.FormEvent<HTMLFormElement>)
      }
    },
    [handleSubmit],
  )
  return { onEnterSubmit }
}
